module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("员工关系")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("异动管理")])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n    数据从钉钉同步到本后台；在本后台新增或修改不会写回钉钉。本页不含退休 Tab。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "inline": "",
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.processType),
      callback: function($$v) {
        _vm.$set(_vm.query, "processType", $$v)
      },
      expression: "query.processType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "REGULAR"
    }
  }, [_vm._v("转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "TRANSFER"
    }
  }, [_vm._v("调岗")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "RESIGN"
    }
  }, [_vm._v("离职")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "OPEN"
    }
  }, [_vm._v("办理中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DONE"
    }
  }, [_vm._v("已办结")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "姓名/钉钉ID"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("从钉钉同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openSubmit
    }
  }, [_vm._v("新建异动（仅本地）")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无异动记录"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": function (p) {
        _vm.query.pageIndex = p;
        _vm.load()
      }
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建异动（仅本地）"
    },
    on: {
      "on-ok": _vm.submit
    },
    model: {
      value: (_vm.showSubmit),
      callback: function($$v) {
        _vm.showSubmit = $$v
      },
      expression: "showSubmit"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.processType),
      callback: function($$v) {
        _vm.$set(_vm.form, "processType", $$v)
      },
      expression: "form.processType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "TRANSFER"
    }
  }, [_vm._v("调岗")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REGULAR"
    }
  }, [_vm._v("转正")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "RESIGN"
    }
  }, [_vm._v("离职")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "员工姓名"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.empName),
      callback: function($$v) {
        _vm.$set(_vm.form, "empName", $$v)
      },
      expression: "form.empName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "钉钉userId"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.dingUserId),
      callback: function($$v) {
        _vm.$set(_vm.form, "dingUserId", $$v)
      },
      expression: "form.dingUserId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "reason", $$v)
      },
      expression: "form.reason"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5139892f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/smartHr/SmartHrTransfer.vue
// module id = 1811
// module chunks = 8